// Shared formatting for attribution return values so cards showing the same figure render it
// identically (sign, 2 decimals + %, and the loading/'N/A' placeholders).
export type ReturnSign = 'positive' | 'negative' | 'none'

export function formatReturnValue(
  value: number | null | undefined,
  isLoading: boolean,
): { text: string; sign: ReturnSign } {
  const hasValue = value !== null && value !== undefined
  if (!hasValue) return { text: isLoading ? '--' : 'N/A', sign: 'none' }
  return {
    text: `${value >= 0 ? '+' : ''}${value.toFixed(2)}%`,
    sign: value >= 0 ? 'positive' : 'negative',
  }
}
